import { Action } from "@/api-schema-enums";
import { useAbility } from "@/casl-provider";
import { generateUuidV4Regex } from "@/common/helpers/utils";
import { BrandDetailView } from "@/views/brand-detail/brand-detail.view";
import { ForbiddenView } from "@/views/common/forbidden.view";
import { NotFoundView } from "@/views/common/notfound.view";
import { Route, Switch } from "wouter";
import { BrandView } from "./brand.view";
import { CreateView } from "./create/create.view";
import { UpdateView } from "./update/update.view";

export function BrandRoutes() {
  const ability = useAbility();
  const brandUpdateUuidRegex = generateUuidV4Regex({ paramName: "uuid", suffix: "/update" });
  const brandDetailUuidRegex = generateUuidV4Regex({ paramName: "uuid" });
  const canManage = ability.can(Action.Manage, "Brand");

  return (
    <Switch>
      <Route path={"/"} component={BrandView} />
      <Route path={"/create"} component={canManage ? CreateView : ForbiddenView} />
      <Route path={brandUpdateUuidRegex} component={canManage ? UpdateView : ForbiddenView} />
      <Route path={brandDetailUuidRegex} component={BrandDetailView} />
      <Route component={NotFoundView} />
    </Switch>
  );
}
